export default "__VITE_ASSET__BYNz_k4i__"